module.exports = __webpack_public_path__ + "static/media/dashboard-pro-introductions-en.8f109677.webp";